import { CRUDEntity } from "../abstracts/CRUDEntity";

export class PaymentSubscriptions extends CRUDEntity {
    constructor(id=null){
        super();
        this.entityClass = 'payments-subscription';
        this.urlRoot = '/payment-subscriptions';
        this.sectionRootUrl = '/payment-subscriptions';
        this.id = id;
    }
}